const toggle = document.getElementById("tax-toggle");

if (toggle !== null) {
    toggle.onclick = () => {
        toggle.form.submit();
    }
}